import {usageSvg as Icon__small__usageSvg} from '../Icon__small/Icon__small--usage.js';
import {usageSvg as Icon__xsmall__usageSvg} from '../Icon__xsmall/Icon__xsmall--usage.js';

export var usage = {
  name: 'usage',
  category: 'icon',
  colorable: true,
  svg: Icon__small__usageSvg,
  alt: {
    Icon__small: Icon__small__usageSvg,
    Icon__xsmall: Icon__xsmall__usageSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
